import React from 'react';

const Summary = ({
    formMasterList,
    handleChangeMaster,
    selectedDiscountValueType,
    handleCheckboxChange,
    receiptDiscount,
    formatCurrency,
    totalPrice,
    subFinal,
    isVatChecked,
    handleVatChange,
    vatAmount,
    grandTotal,
    disabled,
    disabledVat,
    prepaymentAmount,
    outstandingAmount,
}) => {
    return (
        <div className="col-12">
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-4">
                            <div hidden={window.location.pathname === '/payment-voucher'}>
                                <h4 className="card-title">ส่วนลดท้ายบิล</h4>
                                <div className="row mt-3">
                                    <div className="col-3">
                                        <div className="d-flex align-items-center">
                                            <label className="mr-2 flex-grow-1">ส่วนลดมูลค่า</label>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <input
                                            type="text"
                                            className="form-control text-end"
                                            name="discountValue"
                                            value={disabled ? formatCurrency(formMasterList.discountValue || 0) : formMasterList.discountValue || 0}
                                            onChange={handleChangeMaster}
                                            disabled={disabled}
                                            onInput={(e) => {
                                                if (/^0+/.test(e.target.value)) {
                                                    e.target.value = e.target.value.replace(/^0+/, '');

                                                    // หากกรอกเฉพาะจุดทศนิยม ให้เติม 0 ด้านหน้า (เช่น .5 -> 0.5)
                                                    if (e.target.value.startsWith(".")) {
                                                        e.target.value = "0" + e.target.value;
                                                    }
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="col-3">
                                        <div className="row">
                                            <div className="radio-inline">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    name="1"
                                                    checked={selectedDiscountValueType === '1'}
                                                    onChange={handleCheckboxChange}
                                                    disabled={true}
                                                />
                                                <label className="form-check-label">฿</label>
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    name="2"
                                                    checked={selectedDiscountValueType === '2'}
                                                    onChange={handleCheckboxChange}
                                                    disabled={true}
                                                />
                                                <label className="form-check-label">%</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-3">
                                        <input
                                            type="text"
                                            className="form-control text-end"
                                            name="discountValueTotal"
                                            value={formatCurrency(receiptDiscount) || ''}
                                            onChange={handleChangeMaster}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div hidden={window.location.pathname === '/payment-voucher'
                                || window.location.pathname === '/bill'
                                || window.location.pathname === '/invoice'}>
                                <h4 className="card-title">Credit Term</h4>
                                <div className="row mt-3">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-2">
                                                <div className="d-flex align-items-center mb-2">
                                                    <label className="mr-2 flex-grow-1">ระบุวัน</label>
                                                </div>
                                            </div>
                                            <div className="col-4">
                                                <div className="d-flex align-items-center mb-2">
                                                    <input
                                                        type="text"
                                                        className="form-control text-center input-spacing mr-2"
                                                        name="creditTerm"
                                                        value={formMasterList.creditTerm || 0}
                                                        onChange={handleChangeMaster}
                                                        disabled={disabled}
                                                        onInput={(e) => {
                                                            if (/^0+/.test(e.target.value)) {
                                                                e.target.value = e.target.value.replace(/^0+/, '');

                                                                // หากกรอกเฉพาะจุดทศนิยม ให้เติม 0 ด้านหน้า (เช่น .5 -> 0.5)
                                                                if (e.target.value.startsWith(".")) {
                                                                    e.target.value = "0" + e.target.value;
                                                                }
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-6" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-4">
                            <div hidden={false}>
                                <h4 className="card-title">ยอดท้ายบิล</h4>
                                <div className="row mt-3">
                                    <div className="col-12">
                                        <div className="d-flex justify-content-end align-items-center mt-1">
                                            <label>รวมราคา</label>
                                            <input
                                                type="text"
                                                className="form-control text-end input-spacing"
                                                style={{ width: '100px' }}
                                                value={formatCurrency(totalPrice || 0, true)}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="d-flex justify-content-end align-items-center mt-1">
                                            <label>รวมส่วนลด</label>
                                            <input
                                                type="text"
                                                className="form-control text-end input-spacing"
                                                style={{ width: '100px' }}
                                                value={formatCurrency(receiptDiscount || 0, true)}
                                                disabled={true}
                                            />
                                        </div>
                                        <hr />
                                        <div className="d-flex justify-content-end align-items-center mt-1">
                                            <label>ราคาหลังหักส่วนลด</label>
                                            <input
                                                type="text"
                                                className="form-control text-end input-spacing"
                                                style={{ width: '100px' }}
                                                value={formatCurrency(subFinal || 0, true)}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="d-flex justify-content-end align-items-center mt-1">
                                            {
                                                window.location.pathname !== '/bill' && (
                                                    <input
                                                        type="checkbox"
                                                        className="mr-2"
                                                        checked={isVatChecked}
                                                        onChange={handleVatChange}
                                                        disabled={disabled || disabledVat}
                                                    />
                                                )
                                            }
                                            <label className="mr-3">VAT (7%)</label>
                                            <input
                                                type="text"
                                                className="form-control text-end input-spacing"
                                                style={{ width: '100px' }}
                                                value={formatCurrency(vatAmount || 0, true)}
                                                disabled={true}
                                            />
                                        </div>
                                        <hr />
                                        <div className="d-flex justify-content-end align-items-center mt-1">
                                            <label><h5>รวมทั้งสิ้น</h5></label>
                                            <input
                                                type="text"
                                                className="form-control text-end input-spacing"
                                                style={{ width: '100px', color: 'red', fontWeight: 'bold', fontSize: '18px' }}
                                                value={formatCurrency(grandTotal || 0, false)}
                                                disabled={true}
                                            />
                                        </div>
                                        {
                                            window.location.pathname.includes('/product-receipt') &&
                                            prepaymentAmount !== null && (
                                                <>
                                                    <div className="d-flex justify-content-end align-items-center mt-1">
                                                        <label style={{ color: 'red', fontWeight: 'bold' }}>หักชำระล่วงหน้า</label>
                                                        <input
                                                            type="text"
                                                            className="form-control text-end input-spacing"
                                                            style={{ width: '100px', color: 'red' }}
                                                            value={formatCurrency(prepaymentAmount || 0, false)}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                    <div className="d-flex justify-content-end align-items-center mt-1">
                                                        <label style={{ color: 'red', fontWeight: 'bold' }}>ยอดค้างชำระ</label>
                                                        <input
                                                            type="text"
                                                            className="form-control text-end input-spacing"
                                                            style={{ width: '100px', color: 'red', fontWeight: 'bold' }}
                                                            value={formatCurrency(outstandingAmount || 0, false)}
                                                            disabled={true}
                                                        />
                                                    </div>
                                                </>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Summary;